module.exports = __webpack_public_path__ + "images/accents/accent-sl3-html5-a1d3d71f796893d5e01faad3d3632350.webp";